<template>
	<section class="main-content benefits">
		<div class="row">
			<div class="columns column6">
				<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
				<h2>{{ title }}</h2>
				<ul>
					<li v-for="(benefit, key) in benefits" :key="key">
						<font-awesome-icon icon="fa-light fa-circle-check" size="1x" />
						<span>{{ benefit }}</span>
					</li>
				</ul>
				<book-button class="button button-cta reserve-now">
					<span>{{ button }}</span>
				</book-button>
			</div>
		</div>
		<picture>
			<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
			<source :srcset="image" />
			<img :src="image.image" :alt="image.imageAlt" loading="lazy" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	button: { type: String, default: '' },
	benefits: { type: Array, default: () => [] },
	image: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.benefits {
	position: relative;
	padding: 75px 0;
	border-top: 1px solid var(--contentblock-background-color);

	img {
		width: 50%;
		height: 100%;
		object-fit: cover;
		right: 0;
		top: 0;
		bottom: 0;
		position: absolute;
		z-index: 1;
	}

	.row {
		z-index: 2;
		position: relative;
	}

	.column6 {
		padding: 60px 50px;
	}

	ul {
		list-style: none;
		font-size: 16px;
		margin: 30px 0;
		padding-left: 0;
	}

	li {
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		margin: 20px 0;

		span {
			width: calc(100% - 70px);
		}

		svg {
			font-size: 28px;
			color: var(--body-color);
			margin: -2px 20px 2px 0;
		}
	}
}

@media (max-width: 1180px) {
	.benefits .column4 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.benefits {
		display: flex;
		flex-flow: column-reverse wrap;
		padding: 0;

		.column6 {
			width: 100%;
		}

		img {
			position: relative;
			inset: auto;
			width: 100%;
		}
	}
}
</style>
